import MemberInfo from './MemberInfo'
export default MemberInfo
